/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkCustomLensForAws extends models.WellArchitectedFrameworkCustomLens {
    constructor() {
        super();
        this.setDiscriminator("WellArchitectedFrameworkCustomLensForAws");
    }

    getFixupPrototypeFunction() { return WellArchitectedFrameworkCustomLensForAws.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkCustomLensForAws>): WellArchitectedFrameworkCustomLensForAws {
        let obj = Object.assign(new WellArchitectedFrameworkCustomLensForAws(), model);
        WellArchitectedFrameworkCustomLensForAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkCustomLensForAws>): WellArchitectedFrameworkCustomLensForAws {
        if (!model) return null;
        return WellArchitectedFrameworkCustomLensForAws.newInstance(<WellArchitectedFrameworkCustomLensForAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkCustomLensForAws) {
        if (!obj) return;

        models.WellArchitectedFrameworkCustomLensForAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkCustomLensForAws): boolean {
        if (models.WellArchitectedFrameworkCustomLens.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WellArchitectedFrameworkCustomLensForAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.last_sync === "string") {
            this.last_sync = new Date(<string><any>this.last_sync);
        }
    }

    /**
     * States if sync is enabled or not
     */
    sync_enabled: boolean;

    /**
     * Cloud account id
     */
    cloud_account_id: string;

    /**
     * Name of region
     */
    region: string;

    /**
     * States if sync is from aws
     */
    from_aws: boolean;

    /**
     * States if sync is to aws
     */
    to_aws: boolean;

    /**
     * Sync failure reason
     */
    sync_failure_reason: string;

    /**
     * Synced Custom lens name
     */
    lens_name: string;

    /**
     * Last sync time
     */
    last_sync: Date;

}
